import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=51ba023c&scoped=true"
import script from "./roleEdit.vue?vue&type=script&lang=js"
export * from "./roleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba023c",
  null
  
)

export default component.exports